import { Injectable } from '@angular/core';
import { HttpService } from '../../../services/http.service';
@Injectable()
export class MapService {
    constructor(private httpService: HttpService) {}

    getGeoJSONData(geoJsonFileUrl: string): Promise<any> {
        return this.httpService.get(geoJsonFileUrl, true);
    }

    setTheClusterColors(opacity: number) {
        const mapClusterColor = 'rgb(32, 58, 76)';

        const appendOpacity = mapClusterColor.substring(0, mapClusterColor.lastIndexOf(')')) + `, ${opacity})`;
        return appendOpacity;
    }
}
